// firebase
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCV7GUljhrmeEHBV2D9n4ahMC5cZx87IB8",
    authDomain: "krisan-16c54.firebaseapp.com",
    projectId: "krisan-16c54",
    storageBucket: "krisan-16c54.firebasestorage.app",
    messagingSenderId: "1083193442933",
    appId: "1:1083193442933:web:620d7b34516e1e03c4ae3c",
    measurementId: "G-TER59FRPSX",
};

// Initialize Firebase
const fireApp = initializeApp(firebaseConfig);
const analytics = () => {
    getAnalytics(fireApp);
};
// const messaging = getMessaging(fireApp);

export { analytics };
